<template>
  <div class="account-type-selector">
    <SmartLink
      :class="clsx('account-type-selector__personal', {'account-type-selector--selected': selectedType === 'personal'})"
      :method="() => { toggleSelection('personal') }"
    >
      Для Фізичної особи-підприємця
    </SmartLink>
    <SmartLink
      :class="clsx('account-type-selector__organization', {'account-type-selector--selected': selectedType === 'organization'})"
      :method="() => { toggleSelection('organization') }"
    >
      Для Юридичної особи
    </SmartLink>
  </div>
</template>

<script>
import { clsx } from 'clsx';
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    accountType: {
      type: String,
      default: null,
      validator: (value) => value !== null ? ['personal', 'organization'].includes(value) : true,
    },
  },
  data() {
    return {
      selectedType: null,
    };
  },
  created() {
    if (this.accountType) {
      this.toggleSelection(this.accountType);
    }
  },
  components: { SmartLink },
  methods: {
    clsx,
    toggleSelection(type) {
      if (this.selectedType !== type) {
        this.selectedType = type;
      } else {
        this.selectedType = null;
      }

      this.$emit('update-account-type', this.selectedType);
    },
    getAccountType() {
      return this.selectedType;
    },
  },
};
</script>

<style lang="scss" scoped>
.account-type-selector {
  display: flex;
  align-items: center;
  height: 64px;
  background-color: #CADDFC;
  border-radius: 16px;
  padding: 8px;

  @media (max-width: 550px) {
    flex-direction: column;
    height: auto;
  }

  &__personal, &__organization {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #6171E4;
    border-radius: 8px;
    margin: 4px;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;

    @media (max-width: 550px) {
      padding: 12px;
    }

    &:hover {
      background-color: #8FA2F7;
      color: #fff;
    }
  }

  &--selected {
    background-color: #6171E4;
    color: #fff;
  }
}
</style>
